{
  "selectAsField": "\"{value}\" को {fieldName} के रूप में चुनें",
  "typeToSearchField": "{fieldName} खोजने के लिए टाइप करें",
  "licenseFieldLabel": "लाइसेंस प्लेट चुनें (उदा. 215BG2)",
  "licenseFieldName": "लाइसेंस प्लेट",
  "licensePlaceholder": "लाइसेंस प्लेट से खोजें",
  "dotFieldLabel": "DOT नंबर चुनें",
  "dotFieldName": "DOT नंबर",
  "dotPlaceholder": "DOT नंबर से खोजें",
  "chooseOneOption": "नीचे दिए गए विकल्पों में से एक चुनें"
}
